var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-payment-methods"},[_c('img',{attrs:{"src":_vm.largeFormatUrl,"alt":"Payment methods"}}),_c('img',{attrs:{"src":_vm.smallFormatUrl,"alt":"Payment methods"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }